export default function action(...events) {
  return function(target, name) {
    if (!target._actions) target._actions = {};

    for (var i = 0; i < events.length; i++) {
      var event = events[i];
      if (!target._actions[event]) target._actions[event] = [];
      target._actions[event].push(name);
    }
  };
}
